import ContactProfileImage from '@app/components/ContactProfileImage'
import { IContact } from '@app/models/Contact'
import * as React from 'react'
import { Link } from 'react-router-dom'

export interface IConnectionResultItemProps {
  item: IContact
}

export class ConnectionResultItem extends React.PureComponent<
  IConnectionResultItemProps
> {
  public render() {
    return (
      <Link to={`/connection/${this.props.item.id}`} className='result-item'>
        <div className='align-self-center'>
          <ContactProfileImage contact={this.props.item} size={35} />
        </div>
        <div className='flex-grow-1'>
          <div className='font-weight-bold'>
            {this.props.item.firstName} {this.props.item.lastName}
          </div>
          {this.props.item.company && (
            <div className='small'>{this.props.item.company.name}</div>
          )}
        </div>
      </Link>
    )
  }
}
